import React from 'react';
import { Box, Typography } from '@mui/material';

interface InfoFieldProps {
  label: string;
  value: string | undefined;
}

/**
 * InfoField - A reusable component to display label-value pairs
 * Used across CDP profile pages for consistent field display
 */
const InfoField: React.FC<InfoFieldProps> = ({ label, value }) => (
  <Box sx={{ mb: 0.5 }}>
    <Typography
      variant="body2"
      fontWeight={600}
      sx={{ fontSize: '11px', color: 'text.secondary', mb: 0.2 }}
    >
      {label}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: '12px' }}>
      {value || '-'}
    </Typography>
  </Box>
);

export default InfoField;
